module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"cancel":"Отмена","update":"Обновить"}}')
  delete Component.options._Ctor
}
